import axios from 'axios';
import { settings } from '@/plugins/settings';

export interface ICommunityUser {
  id: number;
  email: string | null;
  first_name: string;
  last_name: string;
  phone_number: string | null;
  active: boolean;
  created_at: string;
  locker_id: number | null;
  delivery_token: string | null;
  uses_native_app: boolean;
}

export interface ICommunityUserPage {
  data: ICommunityUser[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

const base = (communityId: number) => settings.endpoint + 'communities/' + communityId + '/users';

export const communityUserService = {
  fetchByCommunity(communityId: number, params?: { page?: number; per_page?: number }): Promise<ICommunityUserPage> {
    return axios({ url: base(communityId), method: 'GET', params }).then((response: any) => {
      const page = response && response.data && response.data.data;
      if (page && Array.isArray(page.data)) return page;
      return { data: [], current_page: 1, last_page: 1, per_page: (params && params.per_page) || 15, total: 0 };
    });
  },
};
